import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKanbanView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconKanbanView"><Path d="M2 4V16H8V4H2Z" fill="currentColor"/><Path d="M9 4V20H15V4H9Z" fill="currentColor"/><Path d="M16 4V14H22V4H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKanbanView;
